module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-Regular.c91092f3.eot";